import React, { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconStrike: React.FC<PropsType> = ({ color, style }) => {
  const iconFillColor = color || '#292929';
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M4.63158 14.0082C4.45263 14.0082 4.30267 13.946 4.18168 13.8214C4.06056 13.6968 4 13.5423 4 13.358C4 13.1738 4.06056 13.0195 4.18168 12.895C4.30267 12.7706 4.45263 12.7084 4.63158 12.7084H19.3684C19.5474 12.7084 19.6973 12.7707 19.8183 12.8952C19.9394 13.0199 20 13.1743 20 13.3587C20 13.5428 19.9394 13.6972 19.8183 13.8217C19.6973 13.946 19.5474 14.0082 19.3684 14.0082H4.63158ZM11.1093 10.9918V7.84167H7.42505C7.17761 7.84167 6.96737 7.75247 6.79432 7.57408C6.62112 7.39555 6.53453 7.17888 6.53453 6.92408C6.53453 6.66914 6.62112 6.45139 6.79432 6.27083C6.96737 6.09028 7.17761 6 7.42505 6H16.5829C16.8304 6 17.0407 6.08919 17.2139 6.26758C17.3871 6.44612 17.4737 6.66278 17.4737 6.91758C17.4737 7.17253 17.3871 7.39028 17.2139 7.57083C17.0407 7.75139 16.8304 7.84167 16.5829 7.84167H12.8987V10.9918H11.1093ZM11.1093 15.7251H12.8987V18.0833C12.8987 18.3379 12.8121 18.5544 12.6387 18.7326C12.4654 18.9109 12.2549 19 12.0072 19C11.7594 19 11.5479 18.9101 11.3724 18.7302C11.197 18.5504 11.1093 18.332 11.1093 18.075V15.7251Z'
        fill={iconFillColor}
      />
    </svg>
  );
};

export default SvgIconStrike;
